/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ModifyGradeBatchRequestViewModel } from "../types/ModifyGradeBatchRequestViewModel.ts";
import { modifyGradeBatchItemViewModelSchema } from "./modifyGradeBatchItemViewModelSchema.ts";

export const modifyGradeBatchRequestViewModelSchema = z.object({
  items: z.array(z.lazy(() => modifyGradeBatchItemViewModelSchema)).nullish(),
}) as unknown as ToZod<ModifyGradeBatchRequestViewModel>;
